export default "__VITE_ASSET__D_q0BCIg__"